import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormatCurrency } from '@src/hooks/useFormatCurrency'

import {
  DiscountText,
  TermsText,
  SingleDiscountContainer,
  CouponAndTextContainer,
  CouponLargeCircle,
  TitleAndTermsContainer,
  StyledAddOnItemsSVG,
} from './SingleDiscounts.styles'

export const AddOnItemsOffer: React.FC<{
  parentMenuName?: string
  addOnItemsMenuMinimumBasketTotal: number | null
}> = ({ parentMenuName, addOnItemsMenuMinimumBasketTotal }) => {
  const { t } = useTranslation('addOnItems')
  const formatCurrency = useFormatCurrency()

  const addOnDescription = addOnItemsMenuMinimumBasketTotal
    ? t('offered_on_orders_over', {
        orderAmount: formatCurrency(addOnItemsMenuMinimumBasketTotal),
      })
    : t('offered_on_all_orders')

  return (
    <SingleDiscountContainer isAddOn>
      <CouponAndTextContainer>
        <CouponLargeCircle isAddOn>
          <StyledAddOnItemsSVG id="basket-boost" />
        </CouponLargeCircle>
        <TitleAndTermsContainer>
          <DiscountText isAddOn>{parentMenuName}</DiscountText>
          <TermsText>{addOnDescription}</TermsText>
        </TitleAndTermsContainer>
      </CouponAndTextContainer>
    </SingleDiscountContainer>
  )
}
